module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/90/assets/images/a06eb8228f52b3b3c39091fdba208904.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_student-management.svg
// module id = /p9h
// module chunks = 0